import { render } from "./Close.vue?vue&type=template&id=7bdeccfc&scoped=true&ts=true"
import script from "./Close.ts?vue&type=script&lang=ts"
export * from "./Close.ts?vue&type=script&lang=ts"

import "./Close.scss?vue&type=style&index=0&id=7bdeccfc&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bdeccfc"]])

export default __exports__